export function randomIntFromInterval(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function randomChartColor() {
  const colors = ["#7562A8", "#C87C36", "#297A94", "#666666"];
  return colors[randomIntFromInterval(1, colors.length - 1)];
}
